import { NavLink } from "react-router-dom";

const DISCORD_URL = "https://discord.gg/FsFnn9NuF3";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
  { label: "Discord", to: "/discord" },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-purple-500/10 bg-[#08090d]"
    >
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[200px] pointer-events-none opacity-60"
        style={{
          background:
            "radial-gradient(circle at 50% 0%, rgba(147,51,234,0.12) 0%, rgba(9,10,15,0) 70%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <NavLink to="/" data-testid="footer-logo-link" className="inline-flex items-center gap-2.5">
              <img
                src="/logo.png"
                alt="Vexora Development logo"
                className="w-7 h-7 object-contain"
              />
              <span className="font-display font-bold text-base text-white">
                Vexora <span className="text-purple-400">Development</span>
              </span>
            </NavLink>
            <p className="mt-4 max-w-sm text-sm text-slate-400 leading-relaxed">
              Professional Minecraft development, custom plugins, and
              innovative solutions for growing communities.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {LINKS.map((link) => (
                <li key={link.to}>
                  <NavLink
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="text-sm text-slate-400 hover:text-purple-300 transition-colors duration-200"
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-white mb-4">Community</h4>
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-discord-link"
              className="inline-flex items-center rounded-lg border border-purple-500/30 hover:border-purple-500/60 bg-purple-500/5 px-4 py-2 text-sm font-medium text-purple-300 hover:text-purple-200 transition-all duration-300"
            >
              Join our Discord
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-purple-500/10">
          <p data-testid="footer-copyright" className="text-xs text-slate-500">
            © {new Date().getFullYear()} Vexora Development. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
